<!--
 * @Author: ljiangyun 396242451@qq.com
 * @Date: 2023-12-05 10:17:43
 * @LastEditors: ljiangyun 396242451@qq.com
 * @LastEditTime: 2024-07-08 10:08:10
 * @FilePath: /光明风控平台_PC端/src/views/sso.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template></template>

<script>
import { getUserInfo } from "../api/index";
import { Message } from "element-ui";

export default {
  methods: {
    jump() {
      let userInfo = localStorage.getItem("bbsUserInfo");
      if (userInfo) {
        let userInfoJson = JSON.parse(userInfo);
        if (userInfoJson.roleName == "融资性贸易权限") {
          window.location.href =
              "https://community.gmfintl.com/brightfood_platform_pc/#/PC/contractManage";
          return
        }
        switch (userInfoJson.homePage) {
          case "多个子公司":
            // ruleName
            window.location.href =
              "https://community.gmfintl.com/brightfood_platform_pc/#/subCompany";
            break;
          case "子公司首页":
            window.location.href =
              "https://community.gmfintl.com/brightfood_platform_pc/#/subCompany";
            break;
          case "部门首页":
            window.location.href =
              "https://community.gmfintl.com/brightfood_platform_pc/#/department";
            break;
          case "总公司首页":
              // window.location.href = "http://localhost:9000/#/"
              window.location.href = "https://community.gmfintl.com/brightfood_platform_pc/#/PC/home";
            break;
          case "梅林首页":
            window.location.href =
              "https://community.gmfintl.com/brightfood_platform_pc/#/PC/gmry";
            break;
          case "集团纪委首页":
          window.location.href =
            "https://community.gmfintl.com/brightfood_platform_pc/#/integrity";
          break;
          default:
            Message.error("登陆过期或未登录，即将跳转 请稍候...");
            setTimeout(() => {
              window.location.href =
                "https://community.gmfintl.com/app/saml2/login";
            }, 1500);
            break;
        }
      }
    },
  },
  created() {
    const { token } = this.$route.query;
    var userAgent = navigator.userAgent.toLowerCase();
    if (
      userAgent.match(
        /(phone|pad|pod|iphone|ipod|ios|ipad|android|mobile|blackberry|iemobile|mqqbrowser|juc|fennec|wosbrowser|browserng|webos|symbian|windows phone|windows mobile|windows ce|ucweb|rv:1.2.3.4|midp)/i
      )
    ) {
      /*window.location.href="你的手机版地址";*/
      window.location.href =
        "https://community.gmfintl.com/brightfood_platform_h5/#/pages/user/login/login?token=" +
        token +
        "&from=platform";
      return false;
    }
    if (token) {
      localStorage.setItem("bbsToken", token);
      getUserInfo().then((res) => {
        if (res.code == 200) {
          localStorage.setItem("bbsUserInfo", JSON.stringify(res.data));
          this.jump();
        }
      });
    } else if (
      localStorage.getItem("bbsToken") &&
      localStorage.getItem("bbsUserInfo")
    ) {
      this.jump();
    } else {
      Message.error("登陆过期或未登录，即将跳转 请稍候...");
      setTimeout(() => {
        window.location.href = "https://community.gmfintl.com/app/saml2/login";
      }, 1500);
    }
  },
};
</script>

<style>
</style>